export function createMap<T extends any>(list: T[], keyExtractor: (item: T) => number): { [key: number]: T }
export function createMap<T extends any>(list: T[], keyExtractor: (item: T) => string): { [key: string]: T }
export function createMap<T extends any>(list: T[], keyExtractor: (item: T) => any): any {
  return list.reduce<{ [key: string]: T }>((c, x) => {
    c[keyExtractor(x)] = x
    return c
  }, {})
}
